// src/components/pages/HayloftCarousel.jsx
import React, { useMemo } from 'react';
import CrossfadeCarousel from './CrossfadeCarousel';

export default function HayloftCarousel() {
  const slides = useMemo(
    () => [
      { src: `${process.env.PUBLIC_URL}/images/hayloft/hayloft 1.jpg`,  alt: 'Hayloft 1' },
      { src: `${process.env.PUBLIC_URL}/images/hayloft/hayloft 2.jpg`,  alt: 'Hayloft 2' },
      { src: `${process.env.PUBLIC_URL}/images/hayloft/hayloft 3.jpg`,  alt: 'Hayloft 3' },
      { src: `${process.env.PUBLIC_URL}/images/hayloft/hayloft 4.jpg`,  alt: 'Hayloft 4' },
      { src: `${process.env.PUBLIC_URL}/images/hayloft/hayloft 5.jpg`,  alt: 'Hayloft 5' },
      { src: `${process.env.PUBLIC_URL}/images/hayloft/hayloft 6.jpg`,  alt: 'Hayloft 6' },
      { src: `${process.env.PUBLIC_URL}/images/hayloft/hayloft 7.jpg`,  alt: 'Hayloft 7' },
      { src: `${process.env.PUBLIC_URL}/images/hayloft/hayloft 8.jpg`,  alt: 'Hayloft 8' },
      { src: `${process.env.PUBLIC_URL}/images/hayloft/hayloft 9.jpg`,  alt: 'Hayloft 9' },
      { src: `${process.env.PUBLIC_URL}/images/hayloft/hayloft 10.jpg`, alt: 'Hayloft 10' },
      { src: `${process.env.PUBLIC_URL}/images/hayloft/hayloft 11.jpg`, alt: 'Hayloft 11' },
      { src: `${process.env.PUBLIC_URL}/images/hayloft/hayloft 12.jpg`, alt: 'Hayloft 12' },
    ],
    []
  );

  return (
    <CrossfadeCarousel
      slides={slides}
    />
  );
}
